var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReject(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.04937 4.21265L3.04937 4.21265L5.90205 1.96265C6.00615 1.88057 6.1603 1.95464 6.1603 2.08877V3.57538H6.16085V3.57594H14.739C15.4478 3.57594 16.0241 4.15225 16.0241 4.8611V14.7852C16.0241 15.494 15.4478 16.0704 14.739 16.0704H2.3238C2.23572 16.0704 2.16364 15.9983 2.16364 15.9102V14.7048C2.16364 14.6168 2.23572 14.5447 2.3238 14.5447H14.4979V14.5441H14.4985V5.10217H14.4979V5.10161H6.16085V5.10217H6.1603V6.58877C6.1603 6.72291 6.00615 6.79698 5.90205 6.7149L3.04937 4.4649L3.04937 4.4649C3.03023 4.44992 3.01474 4.43077 3.0041 4.40892C2.99345 4.38707 2.98792 4.36308 2.98792 4.33877C2.98792 4.31447 2.99345 4.29048 3.0041 4.26863C3.01474 4.24677 3.03023 4.22763 3.04937 4.21265Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.00111607
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReject);
export default __webpack_public_path__ + "static/media/reject.82a1f38f9b75f33f407a0cd3415f6ccc.svg";
export { ForwardRef as ReactComponent };